<template>
  <div>
    <v-layout align-center justify-end row fill-height>
      
      <div>
        <v-menu 
          offset-y
          v-model="menuSpacer"
          :close-on-content-click="false"
          :nudge-width="200"
         >

         <template #activator="{ on: menuSpacer }">
            <v-tooltip bottom>
              <template #activator="{ on: tooltip }">
                <v-btn 
                  icon flat small 
                  class="pa-0 ma-0 text-xs-right"
                  v-on="{ ...tooltip, ...menuSpacer }"
                >
                  <v-icon>format_line_spacing</v-icon>
                </v-btn>
              </template>
              <span>{{ help_space_text }}</span>
            </v-tooltip>
          </template>
     
          <v-card>
            <v-card-text>
              <v-form>
                <v-layout align-center justify-end row fill-height>
                  <v-flex py-0 my-0>
                    <span class="caption"> {{ help_space_text }} </span>
                    <v-slider
                      v-on:click.stop
                      class="pa-0 ma-0"
                      v-model="item.spacing_item_top"
                      prepend-icon="vertical_align_top"
                      max=10
                      min=0
                      v-validate="'max:10'"
                      :data-vv-name="'spacing-up-work-' + index"
                      data-vv-as='espacement au dessus'
                      :error-messages="errors.collect('spacing-up-work-' + index)"
                      data-vv-delay="5000"
                      v-on:blur="$emit('update-item', item.id, item)"
                    ></v-slider>

                    <v-slider
                      v-on:click.stop
                      class="pa-0 ma-0"
                      v-model="item.spacing_item_bottom"
                      prepend-icon="vertical_align_bottom"
                      max=10
                      min=0
                      v-validate="'max:10'"
                      :data-vv-name="'spacing-bottom-work-' + index"
                      data-vv-as='espacement au dessous'
                      :error-messages="errors.collect('spacing-bottom-work-' + index)"
                      data-vv-delay="5000"
                      v-on:blur="$emit('update-item', item.id, item)"
                    ></v-slider>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-menu> 
      </div>



      
      <div class="ml-3 mr-0">
        <v-layout align-center justify-center column fill-height>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon flat small class="pa-0 ma-0"
                v-on="on"
                v-on:click.stop="$emit('pullup-item', index)"
              >
                <v-icon>expand_less</v-icon>
              </v-btn>
            </template>
            <span>{{ tooltipUp }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon flat small class="pa-0 ma-0"
              v-on="on"
              v-on:click.stop="$emit('pulldown-item', index)"
              >
                <v-icon>expand_more</v-icon>
              </v-btn>
            </template>
            <span>{{ tooltipDown }}</span>
          </v-tooltip>
        </v-layout>
      </div>
      
      <v-dialog 
        v-model="dialog[item.id]"
        :key="item.id"
        width="400"
      >
        <v-card>
          <v-card-text class="headline grey lighten-2">
            <p class="text-xs-center"> Supprimer {{ item.title }} ?</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="$set(dialog, item.id, false)"
            >
              Conserver
           </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              @click="$emit('delete-item', item.id, index), $set(dialog, item.id, false)"
            >
              Supprimer
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon flat small color="red" class="ml-2 mr-0"
            v-on="on"
            v-on:click.stop="$set(dialog, item.id, true)"
          >
            <v-icon>close</v-icon>
          </v-btn>                          
        </template>
        <span>{{ tooltipDelete }}</span>
      </v-tooltip>
    </v-layout>
 

  </div>

</template>


<script>


export default {
  props: {
      item: Object,
      index: Number,
    },
    data() {
    return {
      menuSpacer: false,
      help_space_text: "Ajuster l'espacement avant et après cet élément",
      tooltipUp: "Remonter l'élément",
      tooltipDown: "Descendre l'élément",
      tooltipDelete : "Supprimer l'élément",
      dialog: {},
    }
  },
}

</script>
